import { BasePaths, pageName } from './constants';
import SearchPage from './components';
import reducers from './reducers';
import renderPage from '../config/renderPage';
import { gaPageViewMiddleware, dataLakeMiddleware } from '../middleware/pageView';
import analytics from './analytics';

renderPage({
    reducers,
    initialState: window.__REDUX_STATE__,
    routes: BasePaths.map(path => ({
        path,
        component: SearchPage,
    })),
    pageName,
    preGaCustomMiddleware: [
        gaPageViewMiddleware(analytics, window.location),
        dataLakeMiddleware(window.location, window.document, analytics),
    ],
});
